import { useFormContext } from 'react-hook-form'

import { useReceiptInformationValidation } from './validate'
import { useUpdateGuestReceiptInformation } from '../api/update-guest-receipt-information'
import { convertFormValuesToReceiptInformation } from '../model/converter'
import { TReceiptInformationForm } from '../model/form'

type Props = {
  contractId: number
  onSuccess?: () => void
}

export const useUpdateReceiptInformation = ({
  contractId,
  onSuccess,
}: Props) => {
  const { getValues } = useFormContext<TReceiptInformationForm>()

  const { shouldValidateReceiptForm, receiptTrigger } =
    useReceiptInformationValidation()

  const updateReceiptInformationAction = useUpdateGuestReceiptInformation({
    onSuccess,
  })

  const validateForm = async () => {
    let isValid = true

    const hasReceiptChanged = shouldValidateReceiptForm()

    if (hasReceiptChanged) {
      isValid = await receiptTrigger()
    }

    return {
      isValid,
      hasReceiptChanged,
    }
  }

  const updateReceiptInformation = async () => {
    const { isValid } = await validateForm()

    if (!isValid) {
      return
    }

    const formValues = getValues()
    const convertedValues = convertFormValuesToReceiptInformation(formValues)

    updateReceiptInformationAction(contractId, convertedValues)
  }

  return {
    updateReceiptInformation,
  }
}
